// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"f4c2aa1c","770":"5adf6a93","832":"6a275f73"}[chunkId] + ".chunk.js";
};